import axios from "axios";

export const EDUCATION_TERM_URL = "/EducationTerm";

/** Belli Bir Eğitim Dönemi Listesini Elde Eder */
export function getEducationTerms(queryParams) {
  return axios.post(`${EDUCATION_TERM_URL}/GetEducationTerms`, queryParams);
}

/** Belli Bir Eğitim Dönemi Listesini Sayfalama Olmadan Elde Eder */
export function getAllEducationTerms(queryParams) {
  return axios.post(`${EDUCATION_TERM_URL}/GetAllEducationTerms`, queryParams);
}

/** Yeni Bir Eğitim Dönemi Elde Eder */
export function getNewEducationTerm() {
  return axios.get(EDUCATION_TERM_URL);
}

/** Belli Bir Eğitim Dönemini Elde Eder */
export function getEducationTerm(id) {
  return axios.get(`${EDUCATION_TERM_URL}/${id}`);
}

/** Belli Bir Eğitim Dönemini Kaydeder */
export function saveEducationTerm(term) {
  return axios.post(EDUCATION_TERM_URL, term);
}

/** Belli Bir Eğitim Dönemi Listesini Siler */
export function deleteEducationTerms(ids) {
  return axios.post(`${EDUCATION_TERM_URL}/Delete`, ids);
}